import Button from "@app/components/button";
import Image from "next/image";
import { useRouter } from "next/router";

const JoinUsSectionTopContent = () => {
  const router = useRouter();
  const contents = [
    {
      title: "Technology",
      imagePath: "/assets/icons/mdi-cellphone.png",
      desc: "Our technology stack intuitively searches markets, infrastructure, and data, connecting service requests to qualified vendors.",
    },
    {
      title: "Time",
      imagePath: "/assets/icons/mdi-clock-time-eight.png",
      desc: "Less time is wasted reviewing emails, searching databases, and filling out endless bid requests.",
    },
    {
      title: "Platform",
      imagePath: "/assets/icons/mdi-clipboard-text-multiple.png",
      desc: "We provide the right platform, equipped with suitable functions, creating strategic market engagement for our qualified vendor participants.",
    },
  ];

  return (
    <div className="py-16 px-8 md:p-24 flex flex-col space-y-7 items-center text-center">
      <div className="flex flex-col space-y-3">
        <span className="h5 text-secondary-dark">Join us</span>
        <span className="mobile-h3 md:h3 text-text-color-high-em">
          Why haulers work with us?
        </span>
        <span className="pt-2 md:max-w-[716px] text-text-color-mid-em">
          At SimpleWaste, we’ve created a platform that connects client needs to
          service providers. Join our growing network of thousands of haulers
          today.
        </span>
      </div>
      <div className="grid grid-cols-12 gap-y-8 md:gap-x-8 text-text-color-mid-em">
        {contents.map((content) => (
          <div
            key={content.title}
            className="col-span-12 md:col-span-4 flex flex-col items-center space-y-5"
          >
            <Image
              src={content.imagePath}
              alt={content.title}
              height={40}
              width={40}
            />
            <div className="flex flex-col space-y-2">
              <span className="subheading">{content.title}</span>
              <span className="md:max-w-[384px]">{content.desc}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-row py-4">
        <Button
          onClick={() => router.push(process.env.NEXT_PUBLIC_BIDDING_URL)}
        >
          Join Now
        </Button>
      </div>
    </div>
  );
};

export default JoinUsSectionTopContent;
